import {useEffect, useState} from 'react'

import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Typography from '@mui/material/Typography'
import CancelIcon from '@mui/icons-material/Cancel'
import FormControl from '@mui/material/FormControl'
import {useThemeMode} from '../../../../../_metronic/partials'
import {globalDarkMuiTheme, globalLightMuiTheme} from '../utility/globalMuiTheme'
import {Theme, ThemeProvider} from '@mui/material'
import {useMsal} from '@azure/msal-react'
import {ApiWrapper} from '../../../../modules/api/ApiWrapper'

interface IModalSYSMAAProps {
  id: number
  callBack?: any
}

const SYSMAAModal = ({id, callBack}: IModalSYSMAAProps) => {
  const msal = useMsal()
  const apiWrapper = new ApiWrapper(msal.instance)

  const [Opened, setOpened] = useState<boolean>(false)
  const [Title, setTitle] = useState<string>('Eventos')
  const [Events, setEvents] = useState<any>(null)
  const [Data, setData] = useState<any>(null)

  const handleCallBack = (data: any = null) => {
    if (callBack != null) {
      callBack(data)
    }
  }

  const handleOpen = (id: number) => {
    setOpened(true)

    apiWrapper.get('api/v1/MenuAppAudit/carregar?item.ID=' + id).then((response) => {
      if (response.data.data == null) {
        return
      }

      let data = response.data.data
      let events = data.mensagem.split(' | ')

      setData(data)
      setEvents(events)
    })
  }

  const handleClose = () => {
    setOpened(false)
    setEvents(null)
    handleCallBack()
  }

  /* THEME */

  const {mode} = useThemeMode()
  const [muiTheme, setMuiTheme] = useState<Theme>(mode == 'light' ? globalLightMuiTheme : globalDarkMuiTheme)

  const handleUpdateTheme = () => {
    setMuiTheme((mode as any) == 'dark' ? globalDarkMuiTheme : globalLightMuiTheme)
  }

  const formatISOString = (isoString: string) => {
    const [datePart, timePart] = isoString.split('T')
    const [year, month, day] = datePart.split('-')
    const time = timePart.split('.')[0]

    return `${day}/${month}/${year} ${time}`
  }

  useEffect(() => {
    handleUpdateTheme()
  }, [mode])

  /* END THEME */

  useEffect(() => {
    handleOpen(id)
  }, [])

  return (
    <ThemeProvider theme={muiTheme}>
      <Dialog
        open={Opened}
        maxWidth="md"
        fullWidth
        sx={{
          '& .MuiDialog-paper': {
            width: '600px', // Largura personalizada
            maxWidth: 'none' // Permite exceder o limite padrão
          }
        }}
      >
        <DialogTitle>{Title}</DialogTitle>
        <DialogContent dividers={true} sx={{ display: 'flex', flexDirection: 'column' }}>
          <Typography variant="body1"  sx={{ mt: 1 }}>
            <strong>Data Alteração:</strong> {Data ? formatISOString(Data.dtCreated) : ''}
          </Typography>
          <Typography variant="body1" sx={{ mt: 1 }}>
            <strong>Alterado por:</strong> {Data ? Data.nomePessoaCreated : ''}
          </Typography>
          <Typography variant="body1" sx={{ mt: 2 }}>
            <strong>Evento:</strong> {Events ? Events[0] : ''}
          </Typography>
          <Typography variant="body1" sx={{ mt: 2 }}>
            {Events && Events.slice(1).join('\n')}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" startIcon={<CancelIcon />} color="inherit" onClick={handleClose}>
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    </ThemeProvider>

  )
}

export default SYSMAAModal
